import apiService from './apiService';

export const getDepartments = async () => {
  try {
    const response = await apiService.get(`departments`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};
